import IOrder from "@models/IOrder";
import { OrderPaymentSquareNewCard } from "@components/shared/OrderPaymentSquare/OrderPaymentSquareNewCard/OrderPaymentSquareNewCard";
import { ButtonGroup } from "react-bootstrap";
import OwButton from "@components/shared/OwButton/OwButton";
import { useContext, useState } from "react";
import { OrderPaymentSquareTerminal } from "@components/shared/OrderPaymentSquare/OrderPaymentSquareTerminal/OrderPaymentSquareTerminal";
import SupplierContext from "@contexts/SupplierContext";

type Props = {
    orderModel: IOrder;
    cancelFn: (refresh?: boolean) => void;
    confirmFn: (refresh?: boolean) => void;
};

type PaymentMethod = "terminal" | "new_card" | "existing_card";

export const OrderPaymentSquareCharge = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<PaymentMethod>("new_card");

    const handlePaymentMethodChange = (method: PaymentMethod) => {
        setSelectedPaymentMethod(method);
    }

    return <div className={"OrderPaymentSquareCharge"}>
        <div className="text-center mb-4">
            <ButtonGroup>
                {supplierModel.Supplier_Integration.has_square_terminals ? <OwButton className={"btn-primary " + (selectedPaymentMethod === "terminal" ? "active" : "")} title={"terminal"} fn={() => handlePaymentMethodChange("terminal")}/> : null}
                <OwButton className={"btn-primary " + (selectedPaymentMethod === "new_card" ? "active" : "")} title={"new_card"} fn={() => handlePaymentMethodChange("new_card")}/>
                {/* <OwButton className={"btn-primary " + (selectedPaymentMethod === "existing_card" ? "active" : "")} title={"existing_card"} fn={() => handlePaymentMethodChange("existing_card")}/> */}
            </ButtonGroup>
        </div>
        

        {selectedPaymentMethod === "terminal" && <OrderPaymentSquareTerminal orderModel={props.orderModel} cancelFn={props.cancelFn} confirmFn={props.confirmFn}/>}
        {selectedPaymentMethod === "new_card" && <OrderPaymentSquareNewCard orderModel={props.orderModel}/>}
    </div>;
};
